import React, { useState } from "react";
import { Button, Modal, Image } from "react-bootstrap";
import Parser from "html-react-parser";

function Gear(props) {
  // Declare a new state variable, which we'll call "count"
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { data } = props;

  return (
    <>
      <div style={{ paddingTop: "50px" }}>
        <h1 className="widget-title">{data.title}</h1>
        <p>{data.paragraphs[0]}</p>
        <iframe
          width="100%"
          style={{ aspectRatio: "16 / 9", width: "100% !important" }}
          src={data.video_link}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
      <br />
      <p align="center">
        {" "}
        <Button
          variant="primary"
          target="_blank"
          href={data.list_button_link}
          style={{ backgroundColor: "#1b949d" }}
        >
          {data.list_button_name}
        </Button>{" "}
      </p>
    </>
  );
}

export default Gear;
